module.exports = __webpack_public_path__ + "img/icons8-github.c500b4ca.svg";